'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var indigo = {};

exports.__exports = indigo;
